
import Datepicker from 'vuejs-datepicker'

export default {
    props: {
        value: {},
        disabledDates: {},
        highlighted: {},
        label: { type: String, default: ''},
        clearButton: { type: Boolean, default: false },
        rules: { type: String, default: ''},
        validatorName: { type: String, default: ''},
        disabled: { type: Boolean, default: false},
        hideDetails: { type: Boolean, default: false},
        idName: { type: String, default: ''},
        tabindex: { type: String, default: '0' },
        // When true, the calendar popup is displayed centered on the screen
        // with a dimming backdrop instead of being anchored to the input.
        // Opt-in only, so date pickers elsewhere in the app are unaffected.
        centered: { type: Boolean, default: false },
    },
    components: {
        Datepicker
    },
    data(){
        return {
            fsWidth: 0,
            floatLabel: false,
            isFocus: false,
            backdropEl: null,
            unwatchIsOpen: null,
        }
    },
    mounted(){
        this.checkFloatLabel(this._value)
        // vuejs-datepicker@1.6.2 documents @opened but never emits it —
        // only @closed is emitted. Watch isOpen so centered mode can activate.
        this.$nextTick(() => {
            if (!this.$refs.theInput) return
            this.unwatchIsOpen = this.$watch(
                () => {
                    const dp = this.$refs.theInput
                    if (!dp) return null
                    return {
                        open: !!dp.isOpen,
                        day: !!dp.showDayView,
                        month: !!dp.showMonthView,
                        year: !!dp.showYearView,
                    }
                },
                (state, prev) => {
                    if (!state) return
                    if (state.open) {
                        // Treat open transition like the missing @opened event
                        if (!prev || !prev.open) {
                            this.fieldFocus()
                        }
                        if (this.centered) {
                            this.$nextTick(() => this.centerCalendar())
                        }
                    } else if (prev && prev.open) {
                        // Closed — fieldBlur also runs via @closed; keep cleanup here
                        // for centered mode in case @closed timing differs
                        if (this.centered) {
                            this.removeCenteredCalendar()
                        }
                    }
                },
                { deep: true }
            )
        })
    },
    beforeDestroy(){
        if (this.unwatchIsOpen) {
            this.unwatchIsOpen()
            this.unwatchIsOpen = null
        }
        this.removeCenteredCalendar()
    },
    computed: {
        disabledValidate() {
            return !this.rules || this.rules == '' ? true : false
        },
        _value: {
            get(){
                return this.value
            },
            set(val){
                this.$emit('input', val)
            },
        },
        lblWidth: {
            get() {
                if (this.floatLabel)
                    return this.fsWidth + 'px'
                return 0
            }
        }
    },
    watch: {
        _value(val){
            this.checkFloatLabel(val)
        }
    },
    methods: {
        onUpdate() {
            this.$emit('update')
        },
        onSelect() {
            this.$emit('onSelect')
        },
        clickLabel() {
            if(this.$refs.theInput.isOpen ){
                this.$refs.theInput.close()
            } else{
                this.addFocus()
                setTimeout((ev)=>{
                    this.$refs.theInput.isOpen || this.$refs.theInput.showCalendar(ev)
                }, 50)
            }

        },

        fieldFocus() {
            this.addFloatLabel()
            this.addFocus()
        },
        fieldBlur() {
            if(!this._value){
                this.removeFloatLabel()
            }
            this.removeFocus()
            if (this.centered) {
                this.removeCenteredCalendar()
            }
        },
        centerCalendar() {
            const root = this.$refs.theInput && this.$refs.theInput.$el
            if (!root) return

            root.classList.add('vdp-centered-active')

            // Portal every calendar view (day/month/year) to <body> so it escapes
            // modal/accordion overflow and transform containing blocks.
            const calendars = root.querySelectorAll('.vdp-datepicker__calendar')
            calendars.forEach((cal) => {
                if (!cal._vdpOriginalParent) {
                    cal._vdpOriginalParent = cal.parentNode
                    cal._vdpOriginalNextSibling = cal.nextSibling
                }
                if (cal.parentNode !== document.body) {
                    document.body.appendChild(cal)
                }
                cal.classList.add('vdp-centered-calendar')
            })

            if (!this.backdropEl) {
                const backdrop = document.createElement('div')
                backdrop.className = 'vdp-centered-backdrop'
                backdrop.addEventListener('mousedown', this.onBackdropClick)
                document.body.appendChild(backdrop)
                this.backdropEl = backdrop
            }
        },
        onBackdropClick() {
            if (this.$refs.theInput && this.$refs.theInput.isOpen) {
                this.$refs.theInput.close(true)
            }
            this.removeCenteredCalendar()
        },
        removeCenteredCalendar() {
            // Restore any calendars that were moved to <body>
            const portaled = document.body.querySelectorAll('.vdp-centered-calendar')
            portaled.forEach((cal) => {
                cal.classList.remove('vdp-centered-calendar')
                const parent = cal._vdpOriginalParent
                const next = cal._vdpOriginalNextSibling
                if (parent) {
                    if (next && next.parentNode === parent) {
                        parent.insertBefore(cal, next)
                    } else {
                        parent.appendChild(cal)
                    }
                }
                delete cal._vdpOriginalParent
                delete cal._vdpOriginalNextSibling
            })

            const root = this.$refs.theInput && this.$refs.theInput.$el
            if (root) {
                root.classList.remove('vdp-centered-active')
            }
            if (this.backdropEl) {
                this.backdropEl.removeEventListener('mousedown', this.onBackdropClick)
                if (this.backdropEl.parentNode) {
                    this.backdropEl.parentNode.removeChild(this.backdropEl)
                }
                this.backdropEl = null
            }
        },
        checkFloatLabel(val) {
            if(!val && !this.isFocus){
                this.removeFloatLabel()
            } else {
                this.addFloatLabel()
            }
        },
        addFloatLabel() {
            var IdTwo = this.$refs.wrapper.$el.children[0].childNodes[1].children[1] == undefined ? this.$refs.wrapper.$el.children[0].childNodes[1].children[0] : this.$refs.wrapper.$el.children[0].childNodes[1].children[1]
            if(this.$refs.wrapper.$el.parentElement.id != 'sup' && IdTwo.id != 'sup1')
            {
                this.$refs.wrapper.$el.classList.add('float-label')
                setTimeout(()=> {
                    this.fsWidth = this.$refs.lbl.clientWidth
                }, 250)
                this.floatLabel = true
            }
        },
        removeFloatLabel() {
            this.$refs.wrapper.$el.classList.remove('float-label')
            this.floatLabel = false
        },
        addFocus() {
            this.$refs.wrapper.$el.classList.add('focus')
            this.isFocus = true
        },
        removeFocus() {
            this.$refs.wrapper.$el.classList.remove('focus')
            this.isFocus = false
        },
    }
}
